// Created/Updated by Developer - 05/01/2024

import { Component } from '@angular/core';
import { BaseController } from './base.controller';
import {
  ADN_PLUS,
  Action,
  ApiResponseModel,
  ArrayEntitieFields,
  AuthService,
  CtButtonComponent,
  CtDialogComponent,
  CtFormComponent,
  CtInputCheckBoxComponent,
  CtInputNumberComponent,
  CtInputTextComponent,
  CtOtpComponent,
  CtRadioComponent,
  CtSelectComponent,
  CtStepperComponent,
  CtStepperItemComponent,
  CtTableComponent,
  CtrlBaseComponent,
  EntityField,
  HttpService,
  InputBaseComponent,
} from 'components';
import { Router } from '@angular/router';
import { element } from 'protractor';
import { Observable } from 'rxjs';
import { UserOrganizations } from 'components/lib/models/UserOrganizations';
import { resolve } from 'dns';

@Component({
  selector: 'av-vi15',
  template: `<div [id]="getId()" #target></div>`
})
export class AvVi15 extends BaseController {
  public readonly EMAIL_TEXT: string = 'Enviar un correo a ';
  public readonly SMS_TEXT: string = 'Enviar un mensaje de texto al ';

  private stepper: CtStepperComponent;
  private numPatrono: CtInputTextComponent;
  private radioComponents: CtRadioComponent[] = [];
  private otpComponent: CtOtpComponent;
  private dataDTRConfirmacion;
  private readonly BUS_SERVICE_DESC : string = 'Deduccion automatica';
  private monederoIban : string;
  private monederoNumber : number;
  private moneda : string;
  private banco : string;
  private codBanco : string;

  constructor(private router: Router, private authService: AuthService) {
    super();
    super.setViewCode('AV_VI15');
  }

  ngOnDestroy(): void {}

  /* ---------------------- CONTROLLER LOGIC ------------------- */
  private initializeData(action: Action): void {
    this.initializeStepper(action);
    this.setDataCliente(action);
  }

  private initializeStepper(action: Action): void {
    this.stepper = this.utilService.getComponentRef(action.actionParams[0]);
    this.hideBackButton(action);
  }

  private hideBackButton(action: Action): void {
    let stepperItem: CtStepperItemComponent = this.utilService.getComponentRef(
      action.actionParams[3]
    );
    stepperItem.backButtonComponent.setHidden(true);
  }

  private setDataCliente(action: Action): void {
    this.numPatrono = this.utilService.getComponentRef(action.actionParams[2]);
    let docIdPat = this.utilService.getComponentRef(action.actionParams[4]);
    let numCliente: CtInputTextComponent = this.utilService.getComponentRef(
      action.actionParams[1]
    );
    this.numPatrono.setValue(this.loggedUser.user.organization);
    numCliente.setValue(this.loggedUser.user.num_cliente_sigma);
    this.authService.userOrganizations.forEach(
      (organization: UserOrganizations) => {
        if (
          organization.numCliente ==
          this.authService.loggedUser.user.organization
        ) {
          docIdPat.setValue(organization.docIdPat);
        }
      }
    );
    this.getMonederoData(action.actionParams[5], action.actionParams[6]);
  }

  getMonederoData(numClienteInputId : string, headerComponentId : string) {
    let input : CtInputTextComponent = this.utilService.getComponentRef(numClienteInputId);
    this.authService.userOrganizations.forEach(
      (organization: UserOrganizations) => {
        if (
          organization.numCliente ==
          this.authService.loggedUser.user.organization
        ) {
          input.setValue(organization.numCliente);
          const component = this.utilService.getComponentRef(headerComponentId);
          component.event2('onCustomEvent');
        }
      }
    )
  }

  public setMonederoData(action: Action, response: any) {
    if(response){
      response[0].ArrayEntities.List.forEach((element: EntityField) => {
        if (element.Name === 'CUENTA_IBAN') this.monederoIban = element.Value;
        if (element.Name === 'NUM_OBJETO') this.monederoNumber = Number(element.Value);
      });
    }
  }

  public requestAccountData(requestData): Observable<any> {
    return this.httpService.post(
      HttpService.ENDPOINT +
        '/api/process/CUENTAS_BANCARIAS/SER_RET_CUENTA_DEBITAR',
      requestData
    );
  }

  private handleSuccessAccount(
    action: Action,
    data?: any,
    isFavorita: boolean = false
  ): void {
    let titularInput: CtInputTextComponent = this.utilService.getComponentRef(
      action.actionParams[1]
    );
    let entidadInput: CtInputTextComponent = this.utilService.getComponentRef(
      action.actionParams[2]
    );
    let monedaInput: CtInputTextComponent = this.utilService.getComponentRef(
      action.actionParams[3]
    );
    let form: CtFormComponent = this.utilService.getComponentRef(
      action.actionParams[7]
    );
    if (data) {
      this.setFormAccountData(form, data);
    }
    titularInput.setHidden(false);
    entidadInput.setHidden(false);
    monedaInput.setHidden(false);
    this.handleReadOnlyElements(action);



    this.validateIfFavorite(action, isFavorita);
  }

  private handleReadOnlyElements(action: Action) {
    let montoInput: CtInputNumberComponent = this.utilService.getComponentRef(
      action.actionParams[4]
    );
    let aplicacionInput: CtSelectComponent = this.utilService.getComponentRef(
      action.actionParams[5]
    );
    let descInput: CtInputTextComponent = this.utilService.getComponentRef(
      action.actionParams[6]
    );
    montoInput.setReadOnly(false);
    montoInput.formControl.nativeElement.disabled = false;
    descInput.setReadOnly(false);
    descInput.formControl.nativeElement.disabled = false;
  }

  private validateIfFavorite(action: Action, isFavorita: boolean) {
    let checkFavorita: CtInputCheckBoxComponent =
      this.utilService.getComponentRef(action.actionParams[8]);
    if (!isFavorita) {
      checkFavorita.setHidden(false);
    } else checkFavorita.setHidden(true);
  }

  private setFormAccountData(form, response: any): void {
    const elements = form.getFormElements();
    
    elements.forEach((element) => {
      const newValue =
        response && response.length > 0
          ? this.utilService.getStringAttribute(
              element.getModelId(),
              response[0].ArrayEntities.List
            )
          : null;
      element.setValue(newValue);
    });
  }

  //Cuentas favoritas

  private retrieveFavoriteAccounts(action: Action): void {
    let numPatronoValue = this.numPatrono.getValue();
    let requestedCuenta = this.getFavoriteData(numPatronoValue);
    this.requestFavoriteAccounts(requestedCuenta).subscribe({
      next: (response: ApiResponseModel) => {
        let data = response['Data'];
        this.utilService.setAdnToAnyComponent(
          action.actionParams[9],
          response['Data']
        );
      },
      error: (err: any) => {
        this.messageValidationForm(err);
      },
    });
  }

  private getFavoriteData(numPatrono) {
    let contRequest = {
      Type: 0,
      UserCode: 'SVA',
      Source: 'SVA',
      Conditions: {
        Data: [
          {
            Name: 'NUM_CLIENTE',
            Alias: 'NUM_CLIENTE',
            Value: numPatrono,
            Display: '',
            Type: 1,
            FamilyId: '',
          },
        ],
      },
      Data: [],
    };
    return contRequest;
  }

  public requestFavoriteAccounts(requestData): Observable<any> {
    return this.httpService.post(
      HttpService.ENDPOINT +
        '/api/process/CUENTAS_BANCARIAS/SER_RET_CUENTAS_FAVORITAS',
      requestData
    );
  }

  private deleteFavoriteAccount(action: Action): boolean {
    const ctTable : CtTableComponent = this.utilService.getComponentRef(action.actionParams[9]);
    const adn : ADN_PLUS = ctTable.getSelectedAdn();
    const numCuenta = adn.getStringAttribute('COD_CUENTA');
    let success = this.setADNDelete(numCuenta, action);
    return success;
  }

  public setADNDelete(numCuenta, action : Action): boolean {
    let contRequest = {
      Type: 0,
      UserCode: 'SVA',
      Source: 'SVA',
      Conditions: {
        Data: [
          {
            Name: 'NUM_CLIENTE',
            Alias: 'NUM_CLIENTE',
            Value: this.loggedUser.user.organization,
          },

          {
            Name: 'NUM_CUENTA',
            Alias: 'NUM_CUENTA',
            Value: numCuenta,
          },

          {
            Name: 'TIP_CUENTA',
            Alias: 'TIP_CUENTA',
            Value: 'IB',
          },
        ],
      },
      Data: [],
    };

    this.executeDeleteRequest(contRequest).subscribe({
      next: (response: ApiResponseModel) => {
        this.plusAlertService.setCtDialogInfo(
          'Cuenta eliminada',
          'success',
          'success',
          'primary',
          'Se ha eliminado correctamente la cuenta de favoritos.',
          true,
          'Finalizar',
          ''
        );
        const dialog : CtDialogComponent = this.utilService.getComponentRef(action.actionParams[13]);
        dialog.closeDialog();
        return true;
      },
      error: (err: any) => {
        this.messageValidationForm(err.descritption)
        return false;
      },
    });
    return true;
  }

  public executeDeleteRequest(requestData): Observable<any> {
    return this.httpService.post(
      HttpService.ENDPOINT +
        '/api/process/CUENTAS_BANCARIAS/SER_DEL_CUENTA_FAVORITA',
      requestData
    );
  }

  private extractTableData(action: Action): {
    numCuenta: string;
    tipMoneda: string;
    titular: any;
    entidad: string;
  } {
    const value: ADN_PLUS = this.getSelectedAdnFromTable(action);
    const numCuenta = value.getStringAttribute('COD_CUENTA');
    const tipMoneda = value.getStringAttribute('MONEDA');
    const titular = value.getStringAttribute('TITULAR');
    const entidad = value.getStringAttribute('ENTIDAD');

    return { numCuenta, tipMoneda, titular, entidad };
  }

  private getSelectedAdnFromTable(action: Action): ADN_PLUS {
    const table: CtTableComponent = this.utilService.getComponentRef(
      action.actionParams[2]
    );
    return table.getSelectedAdn();
  }

  //Validation
  private validateInputs(action: Action): boolean {
    let numeroCuenta: CtInputTextComponent = this.utilService.getComponentRef(
      action.actionParams[0]
    );
    let monto: CtInputNumberComponent = this.utilService.getComponentRef(
      action.actionParams[4]
    );
    let tipoAplicacion: CtSelectComponent = this.utilService.getComponentRef(
      action.actionParams[5]
    );
    let descripcionTransferencia: CtInputTextComponent =
      this.utilService.getComponentRef(action.actionParams[6]);
    if (
      this.isFieldEmpty(numeroCuenta) ||
      this.isFieldEmpty(monto) ||
      this.isFieldEmpty(tipoAplicacion) ||
      this.isFieldEmpty(descripcionTransferencia)
    ) {
      this.messageValidationForm(
        'Por favor, complete todos los campos para poder continuar.'
      );
      return false;
    } else {
      if (!this.isNumeroCuentaValid(numeroCuenta)) {
        this.messageValidationForm(
          'El número de cuenta no posee 22 caracteres, por favor verifique el numero correspondiente'
        );
        return false;
      }
    }

    const otp : CtOtpComponent = this.utilService.getComponentRef(action.actionParams[13]);
    if(!otp.getStatus()){
      this.messageValidationForm('Por favor, complete la verificación del código de seguridad para continuar.');
      return false;
    }

    return true;
  }

  private isFieldEmpty(element: InputBaseComponent): boolean {
    if (
      element.getCtType() === 'CtInputNumber' &&
      element.getValue() === null
    ) {
      return element.getOldValue() === '';
    } else {
      return element.getValue() === '' || element.getValue() === null;
    }
  }

  private isNumeroCuentaValid(element: CtInputTextComponent): boolean {
    const numeroCuentaValue = element.getValue();
    return numeroCuentaValue !== null && numeroCuentaValue.length === 22;
  }

  private messageValidationForm(message): void {
    this.plusAlertService.setCtDialogInfo(
      'ERROR',
      'error',
      'error',
      'primary',
      message,
      true,
      'Aceptar',
      'Cancelar'
    );
  }

  private cargarDataConfirmacion(action: Action) {
    let form: CtFormComponent = this.utilService.getComponentRef(
      action.actionParams[12]
    );
    let lastForm: CtFormComponent = this.utilService.getComponentRef(
      action.actionParams[14]
    );

    this.storeDTRinfo(action);
    this.setConfirmationData(form, this.dataDTRConfirmacion);
    this.setConfirmationData(lastForm, this.dataDTRConfirmacion);
  }

  private setConfirmationData(
    form: CtFormComponent,
    data: [string, string, string, string, string, string, string]
  ): void {
    const [
      numCuenta,
      nomTitular,
      entidad,
      moneda,
      monto,
      aplicacion,
      descripcionTransferencia,
    ] = data;
    const elements = form.getFormElements();
    const aplicacionFormated =
      aplicacion === 'IM' ? 'Inmediato' : 'No definida';

    elements.forEach((element: InputBaseComponent) => {
      switch (element.getModelId()) {
        case 'COD_CUENTA':
          element.setValue(numCuenta);
          break;
        case 'NOM_TITULAR_CUENTA':
          element.setValue(nomTitular);
          break;
        case 'ENTIDAD':
          element.setValue(entidad);
          break;
        case 'MONEDA':
          if (moneda === 'CRC' || moneda === 'Colones')
            element.setValue('Colones');
          else element.setValue('Dólares');
          break;
        case 'MONTO':
          element.setValue(this.formatCurrency(Number(monto)));
          break;
        case 'APLICACION':
          element.setValue(aplicacionFormated);
          break;
        case 'DESC_TRANSAC':
          element.setValue(descripcionTransferencia);
          break;
        default:
          break;
      }
    });
  }

  formatCurrency(value: number): string {
    const formatter = new Intl.NumberFormat('es-CR', {
      style: 'currency',
      currency: 'CRC',
      minimumFractionDigits: 2,
    });
    return formatter.format(value);
  }

  private storeDTRinfo(
    action: Action
  ){
    const [
      numCuenta,
      nomTitular,
      entidad,
      moneda,
      monto,
      aplicacion,
      descripcionTransferencia,
    ] = [
      this.utilService.getComponentRef(action.actionParams[0]),
      this.utilService.getComponentRef(action.actionParams[1]),
      this.utilService.getComponentRef(action.actionParams[2]),
      this.utilService.getComponentRef(action.actionParams[3]),
      this.utilService.getComponentRef(action.actionParams[4]),
      this.utilService.getComponentRef(action.actionParams[5]),
      this.utilService.getComponentRef(action.actionParams[6])
    ].map((ref) => ref.getValue());

    this.dataDTRConfirmacion = [
      numCuenta,
      nomTitular,
      entidad,
      moneda,
      monto,
      aplicacion,
      descripcionTransferencia
    ];
  }

  private advanceToNextStep(): void {
    this.stepper.changeStep(this.stepper.getCurrentIndex() + 1);
  }

  private cargarSelectedAccount(action: Action): boolean {
    const value: ADN_PLUS = this.getSelectedAdnFromTable(action);
    const codCuentaInput : CtInputTextComponent = this.utilService.getComponentRef(action.actionParams[0]);
    const button: CtInputTextComponent = this.utilService.getComponentRef(action.actionParams[1]);
    const higherValue = [value];
    if (value.getStringAttribute('ENTIDAD')) {
      let cuenta = value.getStringAttribute('COD_CUENTA');
      codCuentaInput.setValue(cuenta);
      button.event2('onClick');
      return true;
    } else {
      return false;
    }
  }

  //Last stepper
  private cargarDataFinal(action: Action): void {
    const [numCuenta,nomTitular,entidad,moneda,monto,aplicacion,descripcionTransferencia] = this.dataDTRConfirmacion;
    let numBanco = this.utilService.getComponentRef(action.actionParams[0]);
    let dialog: CtDialogComponent = this.utilService.getComponentRef(action.actionParams[1]);
    let numCliente = this.loggedUser.user.organization;
    let checkFavorita: CtInputCheckBoxComponent = this.utilService.getComponentRef(action.actionParams[2]);
    let indFav = checkFavorita.getValue();
    let fav;
    if (indFav === 'FAV') fav = 'S';
    else fav ='N';

    dialog.event2('onCustomEvent');
  }

  public onNumCuentaChange(action: Action): void {
    let numCuentaInput: CtInputTextComponent = this.utilService.getComponentRef(action.conditionParams[1]);
    const form: CtFormComponent = this.utilService.getComponentRef(action.conditionParams[0]);
    const form2: CtFormComponent = this.utilService.getComponentRef(action.conditionParams[2]);
    form.getFormElements().forEach((element) => {
      this.handleChangesOnForm(element);
    });
    form2.getFormElements().forEach((element) => {
      if (element instanceof CtSelectComponent) {
        element.formControl.nativeElement.disabled = true;
      } else this.handleChangesOnForm(element);
    });
  }

  private handleChangesOnForm(element) {
    switch (element.getModelId()) {
      case 'COD_CUENTA':
        break;
      case 'TITULAR':
        element.setValue('');
        element.setHidden(true);
        break;
      case 'ENTIDAD':
        element.setValue('');
        element.setHidden(true);
        break;
      case 'MONEDA':
        element.setValue('');
        element.setHidden(true);
        break;
      case 'MONTO':
        element.setValue(0);
        element.setReadOnly(true);
        break;
      case 'DESC_TRANSFER':
        element.setValue('');
        element.setReadOnly(true);
        break;
      default:
        break;
    }
  }

  private handleVerifiedAccount(action: Action, response: any) {
    const buttonConsultar: CtButtonComponent = this.utilService.getComponentRef(
      action.actionParams[13]
    );
    if(response[0]){
      response[0].ArrayEntities.List.forEach((element: EntityField) => {
        if (element.Name == 'MOTIVO_RECHAZO') {
          if (element.Value !== '0') {
            this.getFCLErrorMessage(this.getFCLRequest(element.Value)).subscribe({
              next: (response: ApiResponseModel) => {
                let data = response['Data'][0];
                this.messageValidationForm(data.ArrayEntities.List[0].Value);
              },
              error: (err: any) => {
                this.messageValidationForm(err);
              },
            });
          } else {
            buttonConsultar.event2('onCustomEvent');
          }
        }
      });
    }else{
      this.messageValidationForm('Ha ocurrido un problema al realizar la acción. Por favor, inténtelo nuevamente más tarde.');
    }
  }

  public getFCLErrorMessage(requestData): Observable<any> {
    return this.httpService.post(
      HttpService.ENDPOINT + '/api/process/FCL_GATEWAY/SER_RET_FCL_MSG',
      requestData
    );
  }

  public getFCLRequest(code: string) {
    return {
      Type: 0,
      UserCode: 'SVA',
      Source: 'SVA',
      Conditions: {
        Data: [
          {
            Name: 'MSG_CODE',
            Alias: 'MSG_CODE',
            Value: code,
          },
        ],
      },
      Data: [],
    };
  }

  private handleCustomerAccountData(action: Action, response: any) {
    let cuentaInput: CtInputTextComponent = this.utilService.getComponentRef(action.actionParams[0]);
    let titular: CtInputTextComponent = this.utilService.getComponentRef(action.actionParams[1]);
    let moneda: CtInputTextComponent = this.utilService.getComponentRef(action.actionParams[3]);
    let banco: CtInputTextComponent = this.utilService.getComponentRef(action.actionParams[2]);
    let codBanco: CtInputTextComponent = this.utilService.getComponentRef(action.actionParams[13]);
    if (response) {
      if(response['ResponseMessages']){
        this.showCustomerAccountInfoError(response['ResponseMessages'][0].Message);
        return;
      }
      response.ArrayEntities.List.forEach((element: EntityField) => {
        if (element.Name === 'HOLDER') titular.setValue(element.Value);
        switch (element.Name) {
          case 'HOLDER':
            titular.setValue(element.Value);
            break;
          case 'CURRENCY_CODE':
            if (element.Value === 'CRC' || element.Value === 'Colones') moneda.setValue('Colones');
            else moneda.setValue('Dólares');
            this.moneda = element.Value;
            break;
          case 'ENTITY_NAME':
            banco.setValue(element.Value);
            this.banco = element.Value;
            break;
          case 'TARGET_IBAN':
            cuentaInput.setValue(element.Value);
            break;
          case 'ENTITY_CODE':
            codBanco.setValue(element.Value);
            this.codBanco = element.Value;
            break;
          default:
            break;
        }
      });
      this.isAccountFavorite(cuentaInput.getValue(), action);
    }
  }

  showCustomerAccountInfoError(Message: any) {
    this.plusAlertService.setCtDialogInfo(
      'ERROR',
      'error',
      'error',
      'primary',
      Message,
      true,
      'Aceptar',
      'Cancelar'
    );
  }

  isAccountFavorite(cod_cuenta : string, action : Action): void {
    let numPatronoValue = this.numPatrono.getValue();
    let requestedCuenta = this.getFavoriteData(numPatronoValue);
    this.requestFavoriteAccounts(requestedCuenta).subscribe({
      next: (response: ApiResponseModel) => {
        let data = response['Data'];
        let isFavorite = false;
        if(data.length !== 0){
          data[0].ArrayEntities.List.forEach((element: EntityField) => {
            if (element.Name === 'COD_CUENTA' && element.Value === cod_cuenta) {
              isFavorite = true;
            }
          });
        }
        this.handleSuccessAccount(action, null, isFavorite);
      }
    });
  }

  //Manejo del DTR
  public processPayment(action: Action) {
    const stepper: CtStepperComponent = this.utilService.getComponentRef(action.conditionParams[0]);
    const dialogConfirm: CtDialogComponent = this.utilService.getComponentRef(action.conditionParams[1]);
    
    this.getProcessPaymentParams(action).subscribe({
      next: (response: ApiResponseModel) => {
        let data = response['Data']
        if(data){
          if(data.ArrayEntities.List)
          stepper.changeStep(this.stepper.getCurrentIndex() + 1);
          dialogConfirm.closeDialog();
          this.executeProcessPaymentPostAction(action);
        }
      },
      error: (err: any) => {
        this.messageValidationForm(err)
      },
    })
	}

  executeProcessPaymentPostAction(action : Action) {
    const requestData = this.getProcessPaymentPostActionRequestData(action);
    this.httpService.post(HttpService.ENDPOINT + '/api/process/CUENTAS_BANCARIAS/SER_APLICA_DEBITO_CUENTA',requestData).subscribe({
      next: (response: ApiResponseModel) => {{}}
    });
  }

  private getProcessPaymentPostActionRequestData(action : Action) {
    const cuenta : CtInputTextComponent = this.utilService.getComponentRef(action.actionParams[3]);
    const inputCheckSave : CtInputCheckBoxComponent = this.utilService.getComponentRef(action.actionParams[9]);
    return {
      "Type": 1,
      "UserCode": "SVA",
      "Source": "SVA",
      "Conditions": {
        "Data": [
          {
            "Name": "NUM_CLIENTE",
            "Alias": "NUM_CLIENTE",
            "Value": this.numPatrono.getValue(),
          },
          {
            "Name": "NUM_CUENTA",
            "Alias": "NUM_CUENTA",
            "Value": cuenta.getValue(),
          },
          {
            "Name": "TIP_MONEDA",
            "Alias": "TIP_MONEDA",
            "Value": "COL",
          },
          {
            "Name": "NUM_BANCO",
            "Alias": "NUM_BANCO",
            "Value": this.codBanco,
          },
          {
            "Name": "NOM_BANCO",
            "Alias": "NOM_BANCO",
            "Value": this.banco,
          },
          {
            "Name": "ADD_FAVORITA",
            "Alias": "ADD_FAVORITA",
            "Value": inputCheckSave.getValue(),
          }
        ]
      },
      "Data": [],
      "Params": null
    };
  }

  public getProcessPaymentParams(action: Action): Observable<any> {
    const numCliente : CtInputTextComponent = this.utilService.getComponentRef(action.actionParams[1]);
    const monto : CtInputNumberComponent = this.utilService.getComponentRef(action.actionParams[2]);
    const cuenta : CtInputTextComponent = this.utilService.getComponentRef(action.actionParams[3]);
    const nombreTitular : CtInputTextComponent = this.utilService.getComponentRef(action.actionParams[4]);
    const docIdPat : CtInputTextComponent = this.utilService.getComponentRef(action.actionParams[5]);
    const descriptionTransac : CtInputTextComponent = this.utilService.getComponentRef(action.actionParams[6]);
    const numCuentaMonedero: CtInputTextComponent = this.utilService.getComponentRef(action.actionParams[7]);
    const numObjetoMonedero: CtInputTextComponent = this.utilService.getComponentRef(action.actionParams[8]);

    if(descriptionTransac.getValue().length < 15 || descriptionTransac.getValue().length > 255){
      this.showCustomerAccountInfoError('La descripción de la transacción debe tener entre 15 y 255 caracteres.');
    }

    const requestData: any = this.setProcessPaymentMetadata(numCliente.getValue(),
    nombreTitular.getValue(),docIdPat.getValue(),
    numObjetoMonedero.getValue(),monto.getValue(),descriptionTransac.getValue(),numCuentaMonedero.getValue(),cuenta.getValue());
    return this.httpService.post(
      HttpService.ENDPOINT + '/api/FCL/ProcessDtr',
      requestData
    );
  }

  private setProcessPaymentMetadata(
    customerId: string,
    name: string,
    identification: string,
    productNumber: string,
    amount: string,
    description: string,
    sourceIban: string,
    targetIban: string,
  ): any {
    return {
      Entity: "DUMMY_TEST",
      OperationName: "SER_DUMMY_SERVICE",
      Type: 0,
      Data: [],
      Params: null,
      UserCode: this.authService.loggedUser.user.user_code,
      Source: this.getViewCode(),
      Conditions: {
        Data: [
          {
            Name: "BUS_SERV_DESC",
            Alias: "BUS_SERV_DESC",
            Value: this.BUS_SERVICE_DESC
          },
          {
            Name: "CUSTOMER_ID",
            Alias: "CUSTOMER_ID",
            Value: Number(customerId)
          },
          {
            Name: "TRANSACTION_TYPE",
            Alias: "TRANSACTION_TYPE",
            Value: "DEB"
          },
          {
            Name: "NAME",
            Alias: "NAME",
            Value: name
          },
          {
            Name: "IDENTIFICATION",
            Alias: "IDENTIFICATION",
            Value: this.getCurrentInstitutionIdPat()
          },
          {
            Name: "PRODUCT_NUMBER",
            Alias: "PRODUCT_NUMBER",
            Value: this.monederoNumber
          },
          {
            Name: "AMOUNT",
            Alias: "AMOUNT",
            Value: amount
          },
          {
            Name: "DESCRIPTION",
            Alias: "DESCRIPTION",
            Value: description
          },
          {
            Name: "SOURCE_IBAN",
            Alias: "SOURCE_IBAN",
            Value: this.monederoIban
          },
          {
            Name: "TARGET_IBAN",
            Alias: "TARGET_IBAN",
            Value: targetIban
          },
          {
            Name: "OWNER_USER",
            Alias: "OWNER_USER",
            Value: "FCLAPI"
          }
        ]
      }
    };
  }
  
  getCurrentInstitutionIdPat() {
    for(let institution of this.authService.userOrganizations){
      if(institution.numCliente == this.loggedUser.user.organization){
        return institution.docIdPat;
      }
    }
  }
  /* -------------------- END CONTROLLER LOGIC ----------------- */
}